import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ProjectMigrationComponent } from './project-migration/project-migration.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SynergyComponentsModule } from '@synergy-design-system/angular';

import {
  AuthCallbackComponent,
  AuthenticationService,
  AuthErrorComponent,
  HttpInterceptorService,
  SilentRefreshComponent,
  StsPermissionsService,
} from '@sick-bust-sts/sts-core';

const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', redirectTo: '' },
  { path: 'home', component: ProjectMigrationComponent },
  { path: 'auth-callback', component: AuthCallbackComponent }, // needed to return from SICK ID
  { path: 'silent-refresh', component: SilentRefreshComponent }, // url to trigger silent token refresh
  { path: 'error', component: AuthErrorComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProjectMigrationComponent,
    FileUploadComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {}),
    CommonModule,
    ReactiveFormsModule,
    SynergyComponentsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthenticationService,
    StsPermissionsService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
  }
}
